import { isActiveRoleHost } from './activeRole';

export const CREATIVE_ACCOUNT_REQUIRED_BOOKING_MESSAGE =
  'Switch to Creative to book.';

export const HOST_BOOKING_BLOCKED_ERROR_CODE = 'host-account-cannot-book';

export const getUserType = user => user?.attributes?.profile?.publicData?.userType || null;

export const isHostUser = user => isActiveRoleHost(user);

export const createHostBookingBlockedError = () => ({
  type: 'error',
  name: 'HostBookingBlockedError',
  message: CREATIVE_ACCOUNT_REQUIRED_BOOKING_MESSAGE,
  status: 403,
  statusText: 'Host booking blocked',
  hostBookingBlocked: true,
  apiErrors: [
    {
      code: HOST_BOOKING_BLOCKED_ERROR_CODE,
      title: 'Host booking blocked',
    },
  ],
});

export const isHostBookingBlockedError = error =>
  Boolean(
    error?.hostBookingBlocked ||
      error?.message === CREATIVE_ACCOUNT_REQUIRED_BOOKING_MESSAGE ||
      error?.apiErrors?.some(apiError => apiError?.code === HOST_BOOKING_BLOCKED_ERROR_CODE)
  );
